export const sortMedicalOrganizationVaccine = ({
  medicalOrganizationVaccines,
  sortColumn,
  sortOrder,
}) => (
  medicalOrganizationVaccines.sort((a, b) => {
    if (!sortColumn) return 0; // If no column is selected, do nothing
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }
    // Firestore Timestamp 物件
    if (valueA instanceof Object && valueB instanceof Object && "seconds" in valueA && "seconds" in valueB) {
      const timeA = valueA.seconds * 1000 + Math.floor(valueA.nanoseconds / 1e6);
      const timeB = valueB.seconds * 1000 + Math.floor(valueB.nanoseconds / 1e6);
      return sortOrder === "asc" ? timeA - timeB : timeB - timeA;
    }
    return 0;
  })
)